import { Footer } from "antd/lib/layout/layout";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LabelNotFound from "../../../common/components/Label/LabelNotFound";

//internal import
import LoadingButton from "../../../common/components/LoadingButton/LoadingButton";
import LoadingPage from "../../../common/components/LoadingPage/LoadingPage";
import LogoBis from "../../../common/components/LogoBis/LogoBis";
import MenuHeader from "../../../common/components/MenuHeader/MenuHeader";
import PreventLeavePageItem from "../../../common/components/PreventLeavePageItem/PreventLeavePageItem";
import TypeInputGeneratorItem from "../../../common/components/TypeInputGeneratorItem/TypeInputGeneratorItem";
import { COLORS } from "../../../common/constants/colors";
import { openNotification, tryCatch } from "../../../common/constants/Utilities";
import { PreguntaTipo } from "../../../common/enums/AllEnums";
import { useForm } from "../../../contexts/form";
import { IAnswerDetail, IAnswerDetailOption, IFormAnswerDetail } from "../../../interfaces/IAnswer";
import { GetAnswerHistoricByAnswerID, GetAnswerHistoricByDates, UpdateAnswer } from "../../../services/survey";
import './RespuestaFormulario.css';

const RespuestaFormulario = () => {
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [readOnly, setReadOnly] = useState<boolean>(false);
    const { answerEntitySelected } = useForm();
    const [listEntitySurveided, setListEntitySurveided] = useState<IAnswerDetail[]>([]);
    const [group, setGroup] = useState<string[]>([]);
    const [answerValue, SetAnswerValue] = useState<any>({});
    const [optionValue, SetOptionValue] = useState<any>({});
    const navigate = useNavigate();

    const getHistoricSurvey = () => {
        tryCatch(() => {
            setFormLoading(true);
            GetAnswerHistoricByAnswerID(answerEntitySelected?.answerId!).then(response => {
                setListEntitySurveided(response.data)

            })
                .catch((response) => {
                    openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                })
                .finally(() => setFormLoading(false));
        })
    }


    const handleSetQuestionValue = (value: any, preguntaID: number) => {

        // if(value !== undefined && value !== null) {
        let cloneValue: any = { ...answerValue };
        cloneValue[preguntaID] = value;

        SetAnswerValue(cloneValue);
        // }
    }
    const handleSetOptionValue = (value: any, RespuestaDetalleID: number) => {
        let preguntaId = listEntitySurveided.find(valor => valor.respuestaOpcion.find(x => x.respuestaDetalleID === RespuestaDetalleID))?.preguntaID;
        let oldValueAnswer: any = { ...answerValue };
        oldValueAnswer[preguntaId!] = value;
        SetAnswerValue(oldValueAnswer);
        // if(value !== undefined && value !== null) {
        let cloneValue: any = { ...optionValue };
        cloneValue[RespuestaDetalleID] = value;
        SetOptionValue(cloneValue);
        // }
    }
    const typeQuestion = (preguntaTipo: PreguntaTipo) => {
        let questionType: PreguntaTipo = preguntaTipo;
        if (preguntaTipo === PreguntaTipo.Seleccion || preguntaTipo === PreguntaTipo.SeleccionMultiple) {
            questionType = PreguntaTipo.Texto
        } else if (preguntaTipo === PreguntaTipo.FechaRangoMultiple) {
            questionType = PreguntaTipo.FechaRango
        }
        return questionType;
    }
    const settingAnswers = () => {

        let newListEntitySurveided: IAnswerDetail[] = [];

        listEntitySurveided.forEach(preguntaObj => {



            const result = answerValue[preguntaObj.preguntaID];
            let preguntaActual: IAnswerDetail = preguntaObj;
            if (result !== undefined) {
                if (preguntaObj.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple || preguntaObj.preguntaTipoNombre === PreguntaTipo.FechaRangoMultiple) {

                    let answerOption: IAnswerDetailOption[] = [];
                    preguntaObj.respuestaOpcion.map(OpcionRespuesta => {
                        let _respuestaOpcion: IAnswerDetailOption = OpcionRespuesta;
                        if (optionValue[OpcionRespuesta.respuestaDetalleID] !== undefined) {
                            _respuestaOpcion.respuesta = optionValue[OpcionRespuesta.respuestaDetalleID]
                        }
                        answerOption.push(_respuestaOpcion);
                    })
                    preguntaActual.respuestaOpcion = answerOption;

                } else {

                    let respuestaOpcionActual: IAnswerDetailOption = preguntaActual.respuestaOpcion[0];
                    respuestaOpcionActual.respuesta = answerValue[preguntaObj.preguntaID];
                    preguntaActual.respuestaOpcion[0] = respuestaOpcionActual;
                }
            }
            newListEntitySurveided.push(preguntaActual);
        })


        let answerId: number = newListEntitySurveided.find(pregunta => pregunta.preguntaID)?.respuestaID!;
        updateAnswer(answerId, newListEntitySurveided);
    }

    const updateAnswer = (answerId: number, listAnswer: IAnswerDetail[]) => {
        tryCatch(() => {
            localStorage.setItem('respuestaCheck', JSON.stringify(false));
            setButtonLoading(true)
            UpdateAnswer(answerId, listAnswer)
                .then((response) => {
                    //

                    openNotification('success', 'Actualización', response.msg!);

                    navigate(`/bisformulario/historico`);
                    //
                })
                .catch((response) => {
                    openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                })
                .finally(() => setButtonLoading(false));
        })
    }



    const onSubmit = () => {
        settingAnswers();
    }

    useEffect(() => {

        const groupList: string[] = [];
        listEntitySurveided.map(grupoNombre => grupoNombre.grupo!).forEach(item => {
            if (!groupList.includes(item)) {
                groupList.push(item);
            }
        });
        setGroup(groupList);

    }, [listEntitySurveided]);

    useEffect(() => {
        getHistoricSurvey();
    }, []);

    useEffect(() => {
        if (!!answerEntitySelected?.answerId && answerEntitySelected.fechaDesde === undefined && answerEntitySelected.fechaHasta === undefined) {
            setReadOnly(true)
        } else {
            localStorage.setItem('respuestaCheck', JSON.stringify(true));
        }
        //console.log(listEntitySurveided, "listEntitySurveided");
    }, [])

    return (
        <div >

            <div className={"nav_header"}>
                <LogoBis />
                <MenuHeader currentPage={answerEntitySelected?.formName!} isMenu={false} />
            </div>
            {formLoading.toString() === 'true'
                ? <div className="loading-container"> <LoadingPage message="Cargando..." /></div>
                : listEntitySurveided.length === 0 ? <div className="loading-container"> <LabelNotFound message="No hay datos para mostrar." /></div>
                    : <div className="Nosecuencial">
                        {
                            listEntitySurveided.map(pregunta => (
                                !pregunta.grupo &&
                                <div key={pregunta.preguntaID} className="caja" >
                                    <div className="Nosecuencial-header">

                                        <h3>{pregunta?.grupo}</h3>
                                        <h1>{pregunta?.pregunta}</h1>
                                    </div>

                                    {
                                        (pregunta.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple || pregunta.preguntaTipoNombre === PreguntaTipo.FechaRangoMultiple) ?
                                            pregunta.respuestaOpcion.map(OpcionRespuesta => (
                                                <TypeInputGeneratorItem active={readOnly} key={OpcionRespuesta.respuestaDetalleID} defaultValue={OpcionRespuesta.respuesta} value={typeQuestion(pregunta?.preguntaTipoNombre)} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetOptionValue(value, OpcionRespuesta.respuestaDetalleID)} answerValue={optionValue[OpcionRespuesta.respuestaDetalleID]} isDraggable={!readOnly} />
                                            ))
                                            :
                                            <TypeInputGeneratorItem active={readOnly} key={pregunta.preguntaID} defaultValue={pregunta.respuestaOpcion.map(x => x.respuesta).join(', ')} value={typeQuestion(pregunta?.preguntaTipoNombre)} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetQuestionValue(value, pregunta.preguntaID)} answerValue={answerValue[pregunta.preguntaID]} isDraggable={!readOnly} />

                                    }
                                    {/* <TypeInputGeneratorItem active={readOnly} key={pregunta.preguntaID} defaultValue={pregunta.respuestaOpcion.map(x => x.respuesta).join(', ')} value={typeQuestion(pregunta?.preguntaTipoNombre)} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetQuestionValue(value, pregunta.preguntaID)} answerValue={answerValue[pregunta.preguntaID]} /> */}

                                </div>
                            ))
                        }
                        {group.map((nombregrupo, index) => (
                            <>
                                <h3 className="groupName">{nombregrupo}</h3>
                                {listEntitySurveided.map(pregunta => (
                                    !!pregunta.grupo?.includes(nombregrupo) && <>
                                        < div key={pregunta.preguntaID} className="caja" >
                                            <div className="Nosecuencial-header">
                                                <h1>{pregunta?.pregunta}</h1>
                                            </div>
                                            {
                                                (pregunta.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple || pregunta.preguntaTipoNombre === PreguntaTipo.FechaRangoMultiple) ?
                                                    pregunta.respuestaOpcion.map(OpcionRespuesta => (
                                                        <TypeInputGeneratorItem active={readOnly} key={OpcionRespuesta.respuestaDetalleID} defaultValue={OpcionRespuesta.respuesta} value={typeQuestion(pregunta?.preguntaTipoNombre)} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetOptionValue(value, OpcionRespuesta.respuestaDetalleID)} answerValue={optionValue[OpcionRespuesta.respuestaDetalleID]} isDraggable={pregunta?.preguntaTipoNombre === PreguntaTipo.Coordenadas ? false : undefined} />
                                                    ))
                                                    :
                                                    <TypeInputGeneratorItem active={readOnly} key={pregunta.preguntaID} defaultValue={pregunta.respuestaOpcion.map(x => x.respuesta).join(', ')} value={typeQuestion(pregunta?.preguntaTipoNombre)} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetQuestionValue(value, pregunta.preguntaID)} answerValue={answerValue[pregunta.preguntaID]} isDraggable={pregunta?.preguntaTipoNombre === PreguntaTipo.Coordenadas ? false : undefined} />

                                            }
                                            {/* <TypeInputGeneratorItem active={readOnly} key={pregunta.preguntaID} defaultValue={pregunta.respuestaOpcion.map(x => x.respuesta).join(', ')} value={typeQuestion(pregunta?.preguntaTipoNombre)} OnChange={null} item={pregunta!} SetAnswerValue={(value: any) => handleSetQuestionValue(value, pregunta.preguntaID)} answerValue={answerValue[pregunta.preguntaID]} /> */}

                                        </div>
                                    </>
                                ))}
                            </>
                        ))

                        }
                    </div>

            }

            {formLoading.toString() === 'false' && !readOnly &&
                <Footer className={"answer_footer"}>
                    <LoadingButton
                        type="button"
                        title={"Guardar cambios"}
                        style={{ height: '50px', width: '350px' }}
                        background={COLORS.blue_active}
                        color={COLORS.white_color1}
                        loading={buttonLoading.toString()}
                        method={() => onSubmit()}
                        fontsize={18}
                    />
                </Footer>

            }
            {
!(!!answerEntitySelected?.answerId && answerEntitySelected.fechaDesde === undefined && answerEntitySelected.fechaHasta === undefined)
? (
    <PreventLeavePageItem
      message="¿Desea abandonar la presente página?"
      when={JSON.parse(localStorage.getItem('respuestaCheck') || 'false')}
      method={() => {}}
    />
  )
: null            }
        </div>
    )
}

export default RespuestaFormulario;